import angular from 'angular';
import '../shared.module';

function cpTooltip() {
  return {
    restrict: 'A',
    scope: { cpTooltip: '@', tooltipPosition: '@' },
    link(scope, element) {
      element.addClass('cp-tooltip-host');
      element.attr('data-tooltip', scope.cpTooltip);
      element.attr('data-tooltip-position', scope.tooltipPosition || 'top');
    }
  };
}

angular.module('app.shared').directive('cpTooltip', cpTooltip);
